// extracted by mini-css-extract-plugin
export default {"e_list_item":"IpaHospital_e_list_item__SyL8-"};